import { Outlet } from 'react-router-dom'
import Navbar from '../components/Navbar'
import Footer from '../components/Footer'
import { LoginModalProvider } from '../contexts/LoginModalContext'

const MainLayout = () => {
  return (
    <LoginModalProvider>
      <div className="min-h-screen flex flex-col">
        <Navbar />
        <main className="flex-grow">
          <Outlet />
        </main>
        <Footer />
      </div>
    </LoginModalProvider>
  )
}

export default MainLayout

